import { c as _c } from "react/compiler-runtime";
import { AnimatedChevronIcon } from '@onefootprint/ui';
import { type ReactNode, useId, useState } from 'react';
type SectionProps = {
  title: string;
  /** Selected options in this section, shown as a badge so a collapsed section still says it filters. */
  count?: number;
  defaultOpen?: boolean;
  children: ReactNode;
};
const Section = t0 => {
  const $ = _c(24);
  const {
    title,
    count: t1,
    defaultOpen: t2,
    children
  } = t0;
  const count = t1 === undefined ? 0 : t1;
  const defaultOpen = t2 === undefined ? false : t2;
  const [open, setOpen] = useState(defaultOpen);
  const contentId = useId();
  let t3;
  if ($[0] !== open) {
    t3 = () => setOpen(!open);
    $[0] = open;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== title) {
    t4 = <span className="text-label-2 text-primary">{title}</span>;
    $[2] = title;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== count) {
    t5 = count > 0 && <span className="inline-flex items-center justify-center min-w-5 h-5 px-1 rounded-(--filter-pill-radius) bg-accent text-quinary text-label-3 tabular-nums">{count}</span>;
    $[4] = count;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t4 || $[7] !== t5) {
    t6 = <span className="flex items-center gap-2">{t4}{t5}</span>;
    $[6] = t4;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== open) {
    t7 = <AnimatedChevronIcon isOpen={open} />;
    $[9] = open;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== contentId || $[12] !== open || $[13] !== t3 || $[14] !== t6 || $[15] !== t7) {
    t8 = <button type="button" onClick={t3} aria-expanded={open} aria-controls={contentId} className="flex w-full h-12 items-center justify-between gap-2 text-left">{t6}{t7}</button>;
    $[11] = contentId;
    $[12] = open;
    $[13] = t3;
    $[14] = t6;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== children || $[18] !== contentId || $[19] !== open) {
    t9 = open && <div id={contentId} className="pb-5">{children}</div>;
    $[17] = children;
    $[18] = contentId;
    $[19] = open;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== t8 || $[22] !== t9) {
    t10 = <section className="border-t border-tertiary first:border-t-0">{t8}{t9}</section>;
    $[21] = t8;
    $[22] = t9;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  return t10;
};
export default Section;